export interface User {
    id?: string
    username?: string
    name: string
    email: string
    phone?: string
    status?: UserStatus
    /** Grupos do login, como o `/users/profile` devolve. */
    roles?: string[]
}

export enum UserRole {
    SUPPLIER = 'supplier',
    SIGNER = 'signer',
    // Cidadão que acompanha processos e sessões em leitura (spec 048 do app-frontend).
    VISITOR = 'visitor'
}

export enum UserStatus {
    REMOVED = 'REMOVED',
    UNCONFIRMED = 'UNCONFIRMED',
    CONFIRMED = 'CONFIRMED',
    ARCHIVED = 'ARCHIVED',
    COMPROMISED = 'COMPROMISED',
    UNKNOWN = 'UNKNOWN',
    RESET_REQUIRED = 'RESET_REQUIRED',
    FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
    EXTERNAL_PROVIDER = 'EXTERNAL_PROVIDER'
}
